<template>
  <div>
    <homelogo />
    <v-img src="@/assets/Museo/museo_tecnologia.jpg">
      <span class="leftButton hidden-sm-and-down">
        <v-btn large rounded color="orange" class="r-btn" @click="onclickreturn()">
          <b class="white--text">Visita nuestro museo</b>
        </v-btn>
      </span>
      <div class="centerButtons hidden-md-and-up text-center">
        <v-btn min-width="20%" large rounded color="orange" class="r-btn" @click="onclickreturn()">
          <b class="white--text">Visita nuestro museo</b>
        </v-btn>
      </div>
    </v-img>
    <v-row class="box-center">
      <v-col cols="12" lg="6" md="6" sm="12" class="alignLeft">
        <h1 class="titles">
          <b>Nuestro Museo</b>
        </h1>

        <p class="parrafos1">
          Durante la trayectoria de la Fundación han llegado a
          nuestras instalaciones Elementos Eléctricos y
          Electrónicos cuyo origen se encuentra entre los años
          1.870 a 1.990, nuestro museo cuenta con más de
          200 piezas en perfectas condiciones que muestran la
          evolución tecnología de aparatos como Laptops, PCs,
          teléfonos, electrodomésticos pequeños, celulares,
          entre otros.
          <br />
          <strong>
            Acompañanos a echar un vistazo a algunos de ellos
            en la siguiente galería, si quieres conocer más
            sobre nuestro museo agenda tu visita o envía un
            comentario en el formulario virtual.
          </strong>
        </p>
      </v-col>
      <v-col cols="12" lg="6" md="6" sm="12">
        <v-img src="@/assets/Museo/computador_vintage.png"></v-img>
      </v-col>
    </v-row>
    <v-card max-width="75%" max-height="50%" class="mx-auto">
      <!-- <v-card max-width="75%" max-height="50%" class="mx-auto" v-if="true"> -->
      <v-carousel :show-arrows="true" hide-delimiters height="auto" cycle>
        <v-carousel-item v-for="(slide, i) in slides" :key="i" class="white--text text-center">
          <v-img
            class="align-end"
            aspect-ratio="1.77"
            contain
            :src="require(`@/assets/Museo/${slide.img}.jpg`)"
          >
            <div class="cardBottom text-center">
              <v-card color="rgb(0, 0, 0, 0.3)" class="alignLeft">
                <p
                  class="white--text text-center parrafosSub"
                v-html="slide.text"></p>
              </v-card>
            </div>
          </v-img>
        </v-carousel-item>
      </v-carousel>
    </v-card>
    
        <v-img width="100%" src="@/assets/Museo/donaciones.jpg" >
        <h1 class="titles4" style="padding-left:10%; padding-right:65%; padding-top:10%; text-shadow: black 0.1em 0.1em 0.2em">
          <b>Si tienes alguna de estas interesantes reliquias.</b>
        </h1>

        <p class="parrafoswhite" style="padding-left:10%; padding-right:65%; text-shadow: black 0.1em 0.1em 0.2em">
          Aporta a nuestra iniciativa socio ambiental y realiza tu donación.
        </p>
        </v-img>
    
    <v-row class="box-center">
      <v-col lg="6" md="6" sm="12" cols="12" class="text-center">
        <v-row align="center" justify="center">
          <v-col cols="12" align="center" justify="center">
            <v-img src="@/assets/Museo/agenda.png" width="35%"></v-img>
          </v-col>
            <v-col
            cols="12"
            align="center" justify="center"            
          >
            <h1 class="titles5 font-weidth-black" style="color:orange">Agenda tu visita a nuestro museo.</h1>
          </v-col>
          <v-col cols="12" align="center" justify="center">
            <v-img src="@/assets/Museo/comentarios.png" width="35%" ></v-img>
          </v-col>
          <v-col
            cols="12"
            align="center" justify="center"
          >
            <h1 class="titles5 font-weidth-black" style="color:orange">Envíanos tus aportes o comentarios.</h1>
          </v-col>
          
          <v-col cols="12" align="center" justify="center">
            <v-img src="@/assets/Museo/donacion.png" width="35%" ></v-img>
          </v-col>
          <v-col
            cols="12"
            align="center" justify="center"
          >
            <h1 class="titles5 font-weidth-black" style="color:orange">Realiza tu donación.</h1>
          </v-col>
        </v-row>
        <!-- <h1 class="titles px-10">
          Agenda una visita
          <br />a nuestro museo.
        </h1>
        <br />
        <p class="parrafos1 px-10">Envíanos tus datos para agendar una visita.</p> -->
      </v-col>
      <v-col lg="6" md="6" sm="12" cols="12">
        <!-- <v-row> -->

        <div class="bckForm text-center">
          <h1 class="text-center titles3">Agenda tu visita</h1>
          <br />
          <form @submit.prevent="sendEmail" class="contact-form">
            <v-col cols="12">
              <v-text-field
                label="Institución o Nombre"
                filled
                outlined
                rounded
                solo
                full-width
                name="nombre"
                v-model="nombreDonar"
                color="orange"
                class="borderorange"
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                label="No. de identificación"
                filled
                outlined
                rounded
                solo
                name="identificacion"
                v-model="identificacionDonar"
                color="orange"
                class="borderorange"
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                label="Correo Electronico"
                filled
                outlined
                rounded
                solo
                name="correo"
                v-model="correoDonar"
                color="orange"
                class="borderorange"
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                label="Teléfono / Celular"
                filled
                outlined
                rounded
                solo
                v-model="telefonoDonar"
                name="telefono"
                color="orange"
                class="borderorange"
                hide-details
              ></v-text-field>
            </v-col>
            <br />
            <h1 class="text-center titles3">Fecha visita</h1>
            <br />
            <v-row>
              <v-col lg="6" md="6" sm="12">
                <v-text-field
                  color="orange"
                  class="borderorange"
                  name="fecha"
                  v-model="fechaDonar"
                  hide-details
                  label="dia/mes/año"
                  filled
                  outlined
                  rounded
                  solo
                ></v-text-field>
              </v-col>
              <v-col lg="6" md="6" sm="12">
                <v-text-field
                  color="orange"
                  class="borderorange"
                  name="hora"
                  v-model="horaDonar"
                  hide-details
                  label="Hora"
                  filled
                  outlined
                  rounded
                  solo
                ></v-text-field>
              </v-col>
            </v-row>
            <br />
            <!-- <v-btn @click="recaptcha"  width="100%"
              height="55"
              rounded
              color="orange">recaptcha</v-btn>
             
              -->
            <v-btn
              width="100%"
              height="55"
              rounded
              color="orange"
              class="mx-auto white--text"
              type="submit"
            >Enviar</v-btn>
            <tooltipbtn />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <!-- <v-btn @click="clear">clear</v-btn> -->
          </form>
        </div>

        <!-- </v-row> -->
      </v-col>
    </v-row>
    <v-snackbar v-model="snackbar" vertical :color="color" top>
      {{ text }}
      <template v-slot:action="{ attrs }">
        <v-btn color="indigo" text v-bind="attrs" @click="snackbar = false">Close</v-btn>
      </template>
    </v-snackbar>
  </div>
</template>
<script>
import emailjs from "emailjs-com";
import homelogo from "@/components/homelogo/homelogo.vue";
import tooltipbtn from "@/components/tooltip.vue";


export default {
  components: {
    homelogo,
    tooltipbtn
  },
  data: () => ({
    color: "green",
    text: "",
    snackbar: false,
    nombreDonar: null,
    identificacionDonar: null,
    correoDonar: null,
    telefonoDonar: null,
    fechaDonar: null,
    horaDonar: null,

    slides: [
      { img: "slideshow_1", text: "Radio de onda corta Sony ICF-6800W, fabricado en 1980. Sofisticado receptor de banda mundial con cobertura AM y FM." },
      { img: "slideshow_3", text: "Monitor IBM PC 5110 (1981) Haciendo parte de la quinta generación de computadoras." },
      { img: "slideshow_2", text: "De izquierda a derecha Celular NOKIA 2120 (1994); Motorola Avantel: (1996); NOKIA 5110 (1998); Cisco 7926 (2008); <br> SAMSUNG GT-C3590 (2013); BlackBerry Torch 9800 (2010); Nokia N97 (2008)" },
      { img: "slideshow_4", text: "Portátil Satellite Toshiba 4010 CDT (1998) con procesador de 266 MHz Pentium I.<br> Disco Duro de 4 Gb, unidad de diskette y CD-ROM, 160 MB de memoria. Sistema Operativo Windows 98." },
      { img: "slideshow_5", text: "Laptop Siemens Nixdorf Scenic Mobil 310 (1990) Viene con un Intel Pentium 133 MHz para Windows. <br> Esta computadora puede tomar hasta 40 MB de RAM, con una cantidad fija de 8 no extraíble." },
      { img: "slideshow_6", text: "Ordenador lanzado por Apple 1986 y que estuvo disponible hasta 1990. tenía un procesador Motorola 68000 de 8 MHz, <br> memoria de 1 MB, ampliable a 4 MB, un ROM mayor 128 KB en lugar de 64 KB." },
      { img: "slideshow_7", text: "El primer aparato telefónico útil fue inventado y patentado por Alexander Graham Bell, en los Estados Unidos, el 7 de Marzo de 1876. <br> Este teléfono de pared fue creado en 1879 por la compañía Bell Telephone Company y distribuido a nivel mundial por medio de cinco licencias de fabricación." },
      
    ]
  }),
  methods: {
     recaptcha() {
      return this.$recaptcha('login').then((token) => {
        console.log(token) // Will print the token
      })
      // .catch((e)=>{
        // clave site
        // 6LesXK4ZAAAAAN8wzzIXMTTjjt0-iZhnROb90Y0A
        //clave secreta
        // 6LesXK4ZAAAAAHd0bbwiX72KFfkdXkwgJiHOfpZY
        // console.log(e)
      // })
    },
    onclickreturn() {
      this.$vuetify.goTo("#nosotros");
    },
    sendEmail(e) {
      this.recaptcha().then(()=>{
        emailjs
        .sendForm(
          "gmail",
          "templatedonation",
          e.target,
          "Ef4pW9SP33f_8T-Rv"
        )
        .then(
          result => {
            this.color = "green";
            this.text = "Su correo ha sido enviado";
            this.snackbar = true;
            (this.nombreDonar = null),
              (this.identificacionDonar = null),
              (this.correoDonar = null),
              (this.telefonoDonar = null),
              (this.fechaDonar = null),
              (this.horaDonar = null),
              console.log("SUCCESS!", result.status, result.text);
          },
          error => {
            this.text =
              "Se ha generado un error por favor comuníquese con el administrador";
            this.color = "red";
            this.snackbar = true;
            console.log("FAILED...", error);
          }
        );
    
      }).catch((e)=>{
         this.text =
              "Se ha generado un error por favor comuníquese con el administrador";
            this.color = "red";
            this.snackbar = true;
            console.log("FAILED...", e);
      })
      console.log(e.target);
      // var obj={user_name:"asdf",user_email:"mail",message:"mst"}
      // var x= false
      // if(x)
      }
  },
  

};
</script>
<style scoped>
.floatcenter {
  display: flex;
  display: -webkit-flex;
  /* margin: auto; */
}
.imglogo {
  position: absolute;
  width: 20%;
  z-index: 99;
}
.v-btn {
  text-transform: none !important;
}
.back {
  padding: 20%;
  background-image: url("../assets/Donaciones/fomulario_para_postularme.png");
  background-size: cover;
  /* background-size: auto; */
}
.borderorange {
  border-color: rgb(255, 144, 0);
  box-shadow: 1px 1px 1px rgb(255, 144, 0) inset, 0 0 2px rgba(255, 144, 0);
  outline: 0 none;
  outline-color: orange;
  /* width: 400px; */
}
.caja {
  display: flex;
  flex-flow: column wrap;
  justify-content: center;
  align-items: center;
  background: #333944;
}
.box {
  width: 100%;
}
.leftButton {
  position: absolute;
  padding-top: 23%;
  left: 4%;
  scroll-padding-bottom: 40%;
  /* top: 40%;
  left: 10%; */
  width: 25%;
}
.centerButtons {
  margin: 0;
  margin-top: 45%;
}
.cardBottom {
  margin: 0;
  margin-top: 0%;
}
.alignLeft {
  padding-right: 60px;
  padding-left: 60px;
  /* p
  adding-left: 15px; */
}
.bckForm {
  padding-left: 20%;
  padding-right: 20%;
  padding-top: 22%;
  padding-bottom: 20%;
  background-image: url("../assets/Donaciones/fomulario_para_postularme.png");
  background-size: 100% 100%;
}
</style>